require("core-js/modules/esnext.global-this.js");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t(((e = "undefined" != typeof globalThis ? globalThis : e || self)["dist/usePosition"] = e["dist/usePosition"] || {}, e["dist/usePosition"].js = {}), e.React);
}(this, function (e, l) {
  "use strict";

  function t(t, e) {
    var r,
        n = Object.keys(t);
    return Object.getOwnPropertySymbols && (r = Object.getOwnPropertySymbols(t), e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r)), n;
  }

  function s(n) {
    for (var e = 1; e < arguments.length; e++) {
      var o = null != arguments[e] ? arguments[e] : {};
      e % 2 ? t(Object(o), !0).forEach(function (e) {
        var t, r;
        t = n, e = o[r = e], r in t ? Object.defineProperty(t, r, {
          value: e,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[r] = e;
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function (e) {
        Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(o, e));
      });
    }

    return n;
  }

  function f(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          n || null == u.return || u.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return n(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return n(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function n(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var p = {
    enableHighAccuracy: !1,
    timeout: 1 / 0,
    maximumAge: 0
  };
  e.usePosition = function (e, t) {
    function r(e) {
      var t = e.coords,
          e = e.timestamp;
      u({
        latitude: t.latitude,
        longitude: t.longitude,
        accuracy: t.accuracy,
        speed: t.speed,
        heading: t.heading,
        timestamp: e
      });
    }

    function n(e) {
      c(e.message);
    }

    var o = 0 < arguments.length && void 0 !== e && e,
        i = 1 < arguments.length && void 0 !== t ? t : {},
        a = s(s({}, p), i),
        e = f(l.useState({}), 2),
        t = e[0],
        u = e[1],
        i = f(l.useState(null), 2),
        e = i[0],
        c = i[1];
    return l.useEffect(function () {
      if (navigator && navigator.geolocation) {
        if (o) {
          var e = navigator.geolocation.watchPosition(r, n, a);
          return function () {
            return navigator.geolocation.clearWatch(e);
          };
        }

        navigator.geolocation.getCurrentPosition(r, n, a);
      } else c("Geolocation is not supported");
    }, [a.enableHighAccuracy, a.timeout, a.maximumAge]), s(s({}, t), {}, {
      error: e
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});